/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The DataAutomationRunResult model module.
 * @module model/DataAutomationRunResult
 * @version 1.0.0
 */
export class DataAutomationRunResult {
  /**
   * Constructs a new <code>DataAutomationRunResult</code>.
   * @alias module:model/DataAutomationRunResult
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>DataAutomationRunResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DataAutomationRunResult} obj Optional instance to populate.
   * @return {module:model/DataAutomationRunResult} The populated <code>DataAutomationRunResult</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DataAutomationRunResult();
      if (data.hasOwnProperty('progress'))
        obj.progress = ApiClient.convertToType(data['progress'], 'Number');
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('error'))
        obj.error = ApiClient.convertToType(data['error'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} progress
 */
DataAutomationRunResult.prototype.progress = undefined;

/**
 * @member {Boolean} success
 */
DataAutomationRunResult.prototype.success = undefined;

/**
 * @member {String} error
 */
DataAutomationRunResult.prototype.error = undefined;

